import type { PropsWithChildren } from "react";

export function Chip({ children }: PropsWithChildren) {
  return (
    <span className="inline-flex items-center gap-[5px] rounded-full border border-accent-bright/25 bg-accent-soft px-2 py-[3px] font-mono text-[10px] tracking-[0.06em] text-accent-bright">
      {children}
    </span>
  );
}
